import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import PosLayoutSettings from '~Scenes/Settings-v2/Scenes/PosLayout';
import { useI18n } from '~Hooks';

/** Handheld shell around the shared Settings-v2 POS layout scene */
const PosLayout = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.PosLayoutTitle')}>
      <PosLayoutSettings isHandy />
    </HandyPageWrapper>
  );
};

export default PosLayout;
